var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_c('h3',[_vm._v("Announcements")])])],1),_c('create-news',{staticClass:"mt-4 pa-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }